const converter = new Vue({
    el: '#converter',
    components: {
        'converter-container': () => import(/* webpackChunkName: 'converter' */ '../components/converter/ConverterContainer.vue'),
        'common-file-container': () => import(/* webpackChunkName: 'common-file' */ '../components/converter/CommonFileContainer.vue'),
        'split-files-container': () => import(/* webpackChunkName: 'splitFiles' */ '../components/converter/SplitFilesContainer.vue'),
        'improve-block': () => import(/* webpackChunkName: 'improveBlock' */ '../components/shared/ImproveBlock.vue'),
    },
});
